import React, {  } from 'react'
import { MenuItem, Grid, TextField, FormHelperText} from '@material-ui/core';
import { Field, ErrorMessage } from 'formik';
import DatePicker from '../DatePicker';
import Observers from '../Observers';
import Photos from '../Photos';
import { getErrorProps, getOptions, observers, findPlot } from '../../utils';
import { useStore } from '../../Store'

const VisitDetails = ({ readonly, formik }) => {

  const { plots, settings } = useStore()

  const plotItems = () => {
    return plots.map(item => {
      return (
        <MenuItem key={item.id} value={item.id}>
          {item.description}
        </MenuItem>
      )
    })
  }

  const updateDescription = (value) => {
    const description = (value && value.isValid() ? value.format('DD-MM-YYYY') : '')
    formik.setFieldValue('description', description)
  }

  const show = (name) => {
    const field = settings.visitFields.find(f => f.name === name)
    if (field && field.link && formik.values.extraInfo[field.link.name].match(field.link.matchPattern)) return true
    return false
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <TextField select disabled={readonly} label="telgebied" variant="standard" name="plot" fullWidth {...getErrorProps(formik, "plot")} {...formik.getFieldProps('plot')} >
          {plotItems()}
        </TextField>
      </Grid>

      <Grid item xs={12} >
        <Field disabled={readonly} label="bezoekdatum" variant="standard" name="dateStart" fullWidth {...getErrorProps(formik, "dateStart")} component={DatePicker}
          onChange={updateDescription} />
      </Grid>

      <Grid item xs={12} >
        <Field disabled={readonly} label="deelnemers" variant="standard" name="observers" options={observers(findPlot(plots, formik.values.plot), formik.values.roles)} fullWidth {...getErrorProps(formik, "observers")} component={Observers} />
        <FormHelperText error><ErrorMessage component="div" name="observers" /></FormHelperText>
      </Grid>

      <Grid item xs={12}>
        <TextField select disabled={readonly} label="volledigheid" variant="standard" name="extraInfo.volledigheid" fullWidth  {...getErrorProps(formik, "extraInfo.volledigheid")} {...formik.getFieldProps('extraInfo.volledigheid')} >
          {getOptions(settings.lists["volledigheid"].filter(item => item.value !== "0"))}
        </TextField>
      </Grid>
      {show('volledigheid_opm') &&
        <Grid item xs={12}>
          <TextField disabled={readonly} label="waarom niet geheel geteld?" variant="standard" name="extraInfo.volledigheid_opm" fullWidth  {...getErrorProps(formik, "extraInfo.volledigheid_opm")} {...formik.getFieldProps('extraInfo.volledigheid_opm')} />
        </Grid>
      }

      <Grid item xs={12}>
        <TextField select disabled={readonly} label="nauwkeurigheid" variant="standard" name="extraInfo.nauwkeurigheid" fullWidth  {...getErrorProps(formik, "extraInfo.nauwkeurigheid")} {...formik.getFieldProps('extraInfo.nauwkeurigheid')} >
          {getOptions(settings.lists["nauwkeurigheid"])}
        </TextField>
      </Grid>
      {show('nauwkeurigheid_opm') &&
        <Grid item xs={12}>
          <TextField disabled={readonly} label="hoe geteld?" variant="standard" name="extraInfo.nauwkeurigheid_opm" fullWidth  {...getErrorProps(formik, "extraInfo.volledigheid_opm")} {...formik.getFieldProps('extraInfo.nauwkeurigheid_opm')} />
        </Grid>
      }

      <Grid item xs={12}>
        <TextField select disabled={readonly} label="verstoring" variant="standard" name="extraInfo.verstoring_status" fullWidth  {...getErrorProps(formik, "extraInfo.verstoring_status")} {...formik.getFieldProps('extraInfo.verstoring_status')} >
          {getOptions(settings.lists["verstoring_status"])}
        </TextField>
      </Grid>

      <Grid item xs={12}>
        <TextField select disabled={readonly} label="klimaat" variant="standard" name="extraInfo.klimaat_status" fullWidth  {...getErrorProps(formik, "extraInfo.klimaat_status")} {...formik.getFieldProps('extraInfo.klimaat_status')} >
          {getOptions(settings.lists["klimaat_status"])}
        </TextField>
      </Grid>

      <Grid item xs={12}>
        <TextField select disabled={readonly} label="wegkruipmogelijkheid" variant="standard" name="extraInfo.wegkruip_status" fullWidth  {...getErrorProps(formik, "extraInfo.wegkruip_status")} {...formik.getFieldProps('extraInfo.wegkruip_status')} >
          {getOptions(settings.lists["wegkruip_status"])}
        </TextField>
      </Grid>

      <Grid item xs={12} >
        <TextField disabled={readonly} label="opmerkingen" multiline variant="standard" name="extraInfo.opm_bezoek" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.opm_bezoek")} {...formik.getFieldProps('extraInfo.opm_bezoek')} />
      </Grid>

      <Grid item xs={12}>
        <Photos
          uploads={formik.values.uploads || []}
          setUploads={(uploads) => formik.setFieldValue('uploads', uploads)}
          readonly={readonly}
          formik={formik}
        />
      </Grid>


    </Grid>
  )
}


export default VisitDetails